import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-79a24997")

_pushScopeId("data-v-79a24997")
const _hoisted_1 = { class: "flex mt-0.5 bp-font text-sm rounded-3xl px-3 bg-white dark:bg-gray-600 w-32" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "text-bp-light ml-1 mt-2 -mr-1.5" }, [
  /*#__PURE__*/_createVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    class: "w-4 h-4"
  }, [
    /*#__PURE__*/_createVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M10.5 21l5.25-11.25L21 21m-9-3h7.5M3 5.621a48.474 48.474 0 016-.371m0 0c1.12 0 2.233.038 3.334.114M9 5.25V3m3.334 2.364C11.176 10.658 7.69 15.08 3 17.502m9.334-12.138c.896.061 1.785.147 2.666.257m-4.589 8.495a18.023 18.023 0 01-3.827-5.802"
    })
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "text-gray-800" }, [
  /*#__PURE__*/_createVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    class: "w-6 h-6"
  }, [
    /*#__PURE__*/_createVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M10.5 21l5.25-11.25L21 21m-9-3h7.5M3 5.621a48.474 48.474 0 016-.371m0 0c1.12 0 2.233.038 3.334.114M9 5.25V3m3.334 2.364C11.176 10.658 7.69 15.08 3 17.502m9.334-12.138c.896.061 1.785.147 2.666.257m-4.589 8.495a18.023 18.023 0 01-3.827-5.802"
    })
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _withDirectives(_createVNode("select", {
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$i18n.locale = $event)),
      class: "bg-transparent outline-none rounded-3xl pl-2 py-1.5 pr-2",
      onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeLanguage()))
    }, [
      _hoisted_3,
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.arrLanguageMap, (languageName, languageCode) => {
        return (_openBlock(), _createBlock("option", {
          key: languageCode,
          value: languageCode
        }, _toDisplayString(languageName), 9, ["value"]))
      }), 128))
    ], 544), [
      [_vModelSelect, _ctx.$i18n.locale]
    ])
  ]))
})